const ankets = {
  anketa: 'Анкета',
  ankets: 'Анкеты',
  listOfAnkets: 'Список анкет',
  anketNumber: '№ анкеты',
  anketSearch: 'Поиск анкет',
  anketSearchNumber: 'Поиск по номеру анкеты',
  all: 'Все',
  draft: 'Черновик',
  scoring: 'Оценка',
  scan: 'Прикрепление договора',
  limit: 'Заведение лимита',
  done: 'Готово',
  contractEntry: 'Ввод договора',
  archived: 'Архив',
  upd_down: 'Пересмотр',
  rescore: 'Доработка',
  actionRequired: 'Требуется действие',
  creditLimit: 'Текущий кредитный лимит',
};

export default ankets;
